import React from 'react'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import AccordionSummary from '@material-ui/core/AccordionSummary'
import { makeStyles } from '@material-ui/core/styles'
import Accordion from '@material-ui/core/Accordion'
import styles from '../app_info.module.css'
import PermissionCard from './permission_card'
import CertificateMapper from '../certificate_mapper/certficate_mapper'

const useStyles = makeStyles((theme) => ({
    root: {
        fontFamily:'Vazir !important',
        width: '100%',
        "& .MuiAccordionSummary-content": {
            paddingTop: "1%",
            paddignBottom: "1%"
        },
        "& .MuiAccordionDetails-root": {
            fontSize: "14px",
            color: '#5b4182'
        },
        "& .MuiCollapse-container": {
            transition: "none !important"
        }
    },
    heading: {
        fontWeight: 'bold',
        color: '#2e2744',
        fontSize: "14px"

    }
}))
export default function AppInfoCollapse(props) {

    const classes = useStyles()
    const permissionMapHandler = (data, index) => {

        return (
            <div key={index}>
                <PermissionCard index={index} data={data} />
                {
                    props.data.length !== index + 1 &&
                    <div style={{ border: "solid 1px rgba(17, 25, 42, 0.1)", marginRight: "30px", marginLeft: "30px" }} />
                }
            </div>
        )
    }

    const certificateMapperHandler = (data, index) => {

        return (
            <div key={index}>
                <CertificateMapper data={data} />
            </div>
        )
    }

    return (
        <div className={classes.root}>
            <Accordion elevation={0}>
                <AccordionSummary
                    expandIcon={<div className='px-1 bg-gray-200 rounded-lg'><ExpandMoreIcon/></div>}
                    aria-controls="panel1a-content"
                    id="panel1a-header"
                >
                    <div className="flex items-center">
                        <div className='p-2 bg-gray-200 rounded-lg'><img className={styles.according_title_img} src={`/assets/icons/${props.img}.svg`} alt="Icon" /></div>
                        <div className={styles.according_title_text}> {props.title}</div>
                    </div>
                </AccordionSummary>
                <div className={styles.collapse_card_container}>
                    {
                        props.is_certificate ?
                            <div className={styles.certficate_container}>
                                {
                                    props.data.map(certificateMapperHandler)
                                }
                            </div>
                            :
                            props.data.map(permissionMapHandler)
                    }
                </div>
            </Accordion>
        </div>

    )
}